import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';
import RouteGuards from './appointment-services.guards';

const route = new StepRoute(
  RouteNames.AppointmentServices,
  'services',
  () => import('@/views/steps/ServicesStep.vue'),
);

route.requiresScheduleStep();
route.showSummarySidebar();

route.navigationGuard((to, from, next) => {
  const featureFlagDisabledRoute = RouteGuards.validateFeatureFlagRoute(from);
  if (featureFlagDisabledRoute) {
    next({ name: featureFlagDisabledRoute, params: to.params });
  } else {
    next();
  }
});

export default route.getRoute();
